import { SortOrder } from "antd/es/table/interface";

export function getOrder(order: SortOrder) {
  return order === "ascend" ? "ASC" : "DESC";
}
